

import React, { memo, useState, useEffect, useRef } from 'react';

import onEnterPressed from '@shootsta/on-enter-pressed';
import Slider from 'react-slick';
import cx from 'classnames';
import { SizeMe } from 'react-sizeme';
import Icon from '../../Icon';
import '../styles/_carousel.scss';
import 'slick-carousel/slick/slick.css';





















function PreviousArrow({ onClick, hidden }) {
  return (
    <div
      onClick={hidden ? undefined : onClick}
      className={cx('carousel__left-arrow', {
        'carousel__arrow--hidden': hidden
      })}
      role="button"
      tabIndex={hidden ? -1 : 0}
      aria-hidden={hidden}
      onKeyPress={onEnterPressed({ onClick: hidden ? undefined : onClick })}>

      <Icon name="chevronleft" color="white" size={20} />
    </div>);

}

function NextArrow({ onClick, hidden }) {
  return (
    <div
      onClick={hidden ? undefined : onClick}
      className={cx('carousel__right-arrow', {
        'carousel__arrow--hidden': hidden
      })}
      role="button"
      tabIndex={hidden ? -1 : 0}
      aria-hidden={hidden}
      onKeyPress={onEnterPressed({ onClick: hidden ? undefined : onClick })}>

      <Icon name="chevronright" color="white" size={20} />
    </div>);

}

const DEFAULT_CAROUSEL_CONFIG = {
  dots: false,
  infinite: false,
  speed: 500
};

function Carousel({ children, config, itemWidth, slidesToShow, slideToGo }) {
  const sliderRef = useRef(null);

  if (!children || !Array.isArray(children) || children.length === 1) {
    return children;
  }

  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const carouselConfig = {
    ...DEFAULT_CAROUSEL_CONFIG,
    ...config,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentItemIndex(newIndex);
    }
  };

  useEffect(() => {
    if (
    (slideToGo || slideToGo === 0) &&
    slideToGo !== currentItemIndex &&
    sliderRef &&
    sliderRef.current !== null)
    {
      sliderRef.current.slickGoTo(slideToGo);
    }
  }, [slideToGo]);

  return (
    <SizeMe>
      {({ size }) => {
        const MARGIN = 10;
        const SLIDES_TO_SHOW = slidesToShow || Math.floor(size.width / (itemWidth + MARGIN));
        // Render our own arrows outside the slider (arrows={false}) so react-slick
        // never stamps slick-* classes on them — the styling stays entirely ours.
        const showArrows = carouselConfig.arrows !== false;
        const isAtStart = currentItemIndex === 0;
        const isAtEnd = currentItemIndex + SLIDES_TO_SHOW >= children.length;

        return (
          <div className="carousel">
            {showArrows &&
            <PreviousArrow
              hidden={isAtStart}
              onClick={() => sliderRef.current && sliderRef.current.slickPrev()} />}

            <Slider
              {...carouselConfig}
              arrows={false}
              slidesToShow={SLIDES_TO_SHOW}
              slidesToScroll={SLIDES_TO_SHOW}
              ref={sliderRef}>

              {children}
            </Slider>

            {showArrows &&
            <NextArrow
              hidden={isAtEnd}
              onClick={() => sliderRef.current && sliderRef.current.slickNext()} />}
          </div>);

      }}
    </SizeMe>);

}

export default memo(Carousel);